import React from "react";
import footerLogo from '../assets/images/logo_gray.png'; // 로고 이미지 import

const Footer = () => {

    return (
        <div className="footer">
            <div className="container">
                <div className="info">
                    <span className="name">(주)아이엔아이소프트</span>
                    <span className="info-item">주소 : 서울 영등포구 영신로 166, 반도아이비밸리 1005호</span>
                    <div className="box">
                        <span className="info-item">대표이사 : 이경훈</span>
                        <span className="info-item">전화번호 : 02-569-1171</span>
                        <span className="info-item">이메일 : info@inissoft.com</span>
                    </div>
                    <p className="copy">
                        Copyright © INISSOFT. All Rights Reserved.
                    </p>
                </div>

                <div className="logo">
                    <img src={footerLogo} alt="INISSOFT" className="logo-img" />
                </div>

            </div>  
        </div>
    )
}
export default Footer;